"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFrameFull = void 0;
var react_1 = __importDefault(require("react"));
var IFrameFull = function (_a) {
    var titulo = _a.titulo, url = _a.url;
    return (react_1.default.createElement("iframe", { "data-testid": "iframe-full", src: url, width: "100%", height: "100%", frameBorder: "0", title: titulo, allowFullScreen: true, allow: "autoplay" }));
};
exports.IFrameFull = IFrameFull;
